import { render, staticRenderFns } from "./WizardEdit.vue?vue&type=template&id=0b4c88ca"
import script from "./WizardEdit.vue?vue&type=script&lang=js"
export * from "./WizardEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports